export const synchronized = <TArgs extends any[], TResult>(f: (...args: TArgs) => Promise<TResult>) => {

    let promise: Promise<TResult> | undefined;

    return async (...args: TArgs) => {

        if (!promise) {
            promise = f(...args);
        }

        const result = await promise;
        promise = undefined;
        return result;
    };
};